import {
  dateInputToISO,
  monthRange,
  todayRange,
} from "../utils/DateTime";
import "./DateRangeFilter.css";

export type DateRangePreset =
  | "today"
  | "thisMonth"
  | "lastMonth"
  | "all"
  | "custom";

export interface DateRangeValue {
  preset: DateRangePreset;
  customFrom: string;
  customTo: string;
}

export const DEFAULT_DATE_RANGE_PRESET: DateRangePreset = "thisMonth";

export const emptyDateRangeValue = (): DateRangeValue => ({
  preset: DEFAULT_DATE_RANGE_PRESET,
  customFrom: "",
  customTo: "",
});

export const resolveDateRange = (
  value: DateRangeValue,
): { from?: string; to?: string } => {
  switch (value.preset) {
    case "today":
      return todayRange();
    case "thisMonth":
      return monthRange();
    case "lastMonth": {
      const now = new Date();
      const from = new Date(
        now.getFullYear(),
        now.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );
      const to = new Date(
        now.getFullYear(),
        now.getMonth(),
        0,
        23,
        59,
        59,
        999,
      );
      return { from: from.toISOString(), to: to.toISOString() };
    }
    case "custom":
      return {
        from: dateInputToISO(value.customFrom),
        to: dateInputToISO(value.customTo, true),
      };
    case "all":
    default:
      return { from: undefined, to: undefined };
  }
};

interface DateRangeFilterProps {
  label?: string;
  value: DateRangeValue;
  disabled?: boolean;
  onChange: (value: DateRangeValue) => void;
}

const DateRangeFilter = ({
  label = "Date Range",
  value,
  disabled = false,
  onChange,
}: DateRangeFilterProps) => (
  <div className="date-range-filter">
    <label className="date-range-filter__preset">
      <span>{label}</span>
      <select
        value={value.preset}
        disabled={disabled}
        onChange={(e) =>
          onChange({ ...value, preset: e.target.value as DateRangePreset })
        }
      >
        <option value="today">Today</option>
        <option value="thisMonth">This Month</option>
        <option value="lastMonth">Last Month</option>
        <option value="all">All Time</option>
        <option value="custom">Custom Range</option>
      </select>
    </label>
    {value.preset === "custom" && (
      <span className="date-range-filter__custom">
        <label className="date-range-filter__field">
          <span>From</span>
          <input
            type="date"
            disabled={disabled}
            value={value.customFrom}
            onChange={(e) => onChange({ ...value, customFrom: e.target.value })}
          />
        </label>
        <label className="date-range-filter__field">
          <span>To</span>
          <input
            type="date"
            disabled={disabled}
            value={value.customTo}
            onChange={(e) => onChange({ ...value, customTo: e.target.value })}
          />
        </label>
      </span>
    )}
  </div>
);

export default DateRangeFilter;
